// VFX: Donut Progress Chart
// Category: pie-donut · Tags: data, donut, chart, progress, circular
// Donut chart que preenche em arco com spring. Percentual central com countUp.
import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

const clamp = { extrapolateLeft: "clamp", extrapolateRight: "clamp" } as const;

export interface DonutProgressChartProps {
  value?: number;
  sublabel?: string;
  color?: string;
  size?: number;
  dark?: boolean;
}

export default function DonutProgressChart({
  value = 78,
  sublabel = "Retention Rate",
  color = "#10b981",
  size = 260,
  dark = true,
}: DonutProgressChartProps) {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const p = spring({ frame, fps, config: { damping: 160, stiffness: 120, mass: 0.9 } });
  const pct = interpolate(p, [0, 1], [0, value / 100], clamp);
  const bg = dark ? "#060608" : "#fafafa";
  const track = dark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.06)";
  const mutedColor = dark ? "#94a3b8" : "#999";
  const r = size / 2 - 20;
  const circ = 2 * Math.PI * r;
  const stroke = circ * (1 - pct);
  return (
    <AbsoluteFill style={{ background: bg, justifyContent: "center", alignItems: "center" }}>
      <div style={{ position: "relative", width: size, height: size }}>
        <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={track} strokeWidth={18} />
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={18} strokeLinecap="round" strokeDasharray={circ} strokeDashoffset={stroke} style={{ filter: `drop-shadow(0 0 10px ${color}88)` }} />
        </svg>
        <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <div style={{ fontSize: 56, fontWeight: 900, color, fontFamily: "system-ui", lineHeight: 1 }}>
            {Math.round(interpolate(p, [0, 1], [0, value], clamp))}%
          </div>
          {sublabel && (
            <div style={{ fontSize: 14, color: mutedColor, fontFamily: "system-ui", marginTop: 8, opacity: interpolate(frame, [15, 28], [0, 1], clamp), textAlign: "center", letterSpacing: 1 }}>
              {sublabel}
            </div>
          )}
        </div>
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
